import * as ActionTypes from "../constants/ActionTypes";

// **************************************************************************************************************
export const databaseReducer = (state = {databaseData: {}, databaseOrder: [], databaseSelected: false, defaultOption: false}, action) => {

    switch (action.type) {
        case ActionTypes.DATABASE_SUCCESS:

            const keyValueTypes = {}
            let defaultOption = false

            Object.entries(action.response.entities.database).forEach(([key, value]) => {
                keyValueTypes[key] = value
                if (value.default) {
                    defaultOption = value
                }
            })

            return {databaseData: keyValueTypes, databaseOrder: action.response.result, defaultOption: defaultOption}

        case ActionTypes.SELECT_DATABASE:
            return Object.assign({}, state, {databaseSelected: action.selected})

        default:
            return state
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/Database.js
 **/